module.exports = __webpack_public_path__ + "static/img/GRS_CERTIFICATION 2020.330da97e.jpg";